import { Capture } from "../../types/api/models/capture";
import { Detection } from "../../types";

export function isDetection(item: Capture | Detection): item is Detection {
  return "capture_uuid" in item;
}
